import React from 'react';
import {
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { FormTextField } from '@personal-dashboard/ui';
import { SourceField } from '../types';
import {
  FieldType,
  ChartType,
  Aggregation,
  chartTypeOptions,
  aggregationOptions,
} from './widgetOptions';

interface CreateWidgetFormFieldsProps {
  sourceFields: SourceField[];
  fieldType: FieldType | undefined;
  onFieldChange: (fieldId: string) => void;
}

export const CreateWidgetFormFields: React.FC<CreateWidgetFormFieldsProps> = ({
  sourceFields,
  fieldType,
  onFieldChange,
}) => {
  const { control } = useFormContext();
  const fieldOptions = sourceFields.map((f) => ({ value: f.fieldId, label: f.label }));

  return (
    <Stack spacing={2}>
      <FormTextField
        name="title"
        label="Widget Title"
        fullWidth
        size="small"
        rules={{ required: 'Title is required' }}
      />
      <FormControl fullWidth size="small" required>
        <InputLabel>Source Field</InputLabel>
        <Controller
          name="fieldId"
          control={control}
          rules={{ required: 'Source field is required' }}
          render={({ field, fieldState: { error } }) => (
            <>
              <Select
                {...field}
                label="Source Field"
                value={field.value || ''}
                onChange={(e) => onFieldChange(e.target.value)}
              >
                {fieldOptions.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
              {error && <FormHelperText>{error.message}</FormHelperText>}
            </>
          )}
        />
      </FormControl>
      {fieldType && (
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <FormControl fullWidth size="small">
            <InputLabel>Chart Type</InputLabel>
            <Controller
              name="chartType"
              control={control}
              render={({ field }) => (
                <Select {...field} label="Chart Type" value={field.value || ''}>
                  {chartTypeOptions(fieldType).map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
          </FormControl>
          <FormControl fullWidth size="small">
            <InputLabel>Aggregation</InputLabel>
            <Controller
              name="aggregation"
              control={control}
              render={({ field }) => (
                <Select {...field} label="Aggregation" value={field.value || ''}>
                  {aggregationOptions(fieldType).map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
          </FormControl>
        </Stack>
      )}
    </Stack>
  );
};

export default CreateWidgetFormFields;
